import produce from 'immer';
import * as immer from 'immer';
import { constants } from '../actions/constants/fichaOptometrica.constants';

immer.setAutoFreeze(false);

const initialState = {
  usuarios: [],
  prescriptores: [],
  graduaciones: [],
  graduacionSelected: {},
  error: null,
  fichaOptometrica: {},
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case constants.GET_USUARIOS_REQUEST: {
      if (payload && payload.incremental) return draft;
      return {
        ...draft,
        usuarios: [],
      };
    }
    case constants.GET_USUARIOS_REQUEST_SUCCESS: {
      const { usuarios, total, incremental } = payload;
      return {
        ...draft,
        usuarios: payload && incremental ? [...draft.usuarios, ...usuarios] : usuarios,
        totalUsuarios: total,
      };
    }
    case constants.GET_USUARIOS_REQUEST_FAILURE: {
      return {
        ...draft,
        usuarios: [],
        error: payload.toString(),
      };
    }
    case constants.GET_PRESCRIPTORES_REQUEST: {
      if (payload && payload.incremental) return draft;
      return {
        ...draft,
        prescriptores: [],
      };
    }
    case constants.GET_PRESCRIPTORES_REQUEST_SUCCESS: {      
      const { prescriptores, total, incremental } = payload;
      const nuevosPrescriptores = prescriptores.map((p:any) => ({
        id: p.id, perfil: p.profesion, tiendaId: p.tienda_id, nombreCompleto: p.nombre_completo,
      }));
      return {
        ...draft,
        prescriptores: incremental ? [...draft.prescriptores, ...nuevosPrescriptores] : nuevosPrescriptores,
        totalPrescriptores: total,
      };
    }
    case constants.GET_PRESCRIPTORES_REQUEST_FAILURE: {
      return {
        ...draft,
        prescriptores: [],
        error: payload.toString(),
      };
    }
    case constants.GET_GRADUACIONES_REQUEST: {
      return {
        ...draft,
        graduaciones: [],
      };
    }
    case constants.GET_GRADUACIONES_REQUEST_SUCCESS: {
      return {
        ...draft,
        graduaciones: payload,
      };
    }
    case constants.GET_GRADUACIONES_REQUEST_FAILURE: {
      return {
        ...draft,
        graduaciones: [],
        error: payload.toString(),
      };
    }

    case constants.GET_OLD_GRADUACION_REQUEST: {
      return {
        ...draft,
        graduacionSelected: {...draft.graduacionSelected},
      };
    }
    case constants.GET_GRADUACION_REQUEST: {
      return {
        ...draft,
        graduacionSelected: {},
      };
    }
    case constants.GET_GRADUACION_REQUEST_SUCCESS: {
      return {
        ...draft,
        graduacionSelected: payload,
      };
    }
    case constants.GET_GRADUACION_REQUEST_FAILURE: {
      return {
        ...draft,
        graduacionSelected: {},
        error: payload.toString(),
      };
    }
    case constants.GET_GRADUACION_EXTENDIDA_REQUEST: {
      return {
        ...draft,
        graduacionSelected: {},
      };
    }
    case constants.GET_GRADUACION_EXTENDIDA_REQUEST_SUCCESS: {
      return {
        ...draft,
        graduacionSelected: payload,
      };
    }
    case constants.GET_GRADUACION_EXTENDIDA_REQUEST_FAILURE: {
      return {
        ...draft,
        graduacionSelected: {},
        error: payload.toString(),
      };
    }
    case constants.SET_GRADUACION_REQUEST: {
      return {
        ...draft,
        fichaOptometrica: {},
      };
    }
    case constants.SET_GRADUACION_REQUEST_SUCCESS: {
      return {
        ...draft,
        fichaOptometrica: payload,
        graduacionSelected: {},
      };
    }
    case constants.SET_GRADUACION_REQUEST_FAILURE: {
      return {
        ...draft,
        fichaOptometrica: {},
        error: payload.toString(),
      };
    }

    default:
      return draft;
  }
});
